export default __webpack_public_path__ + "static/media/git-push.301b1154.svg";